// removed by extract-text-webpack-plugin


//////////////////
// WEBPACK FOOTER
// ./src/scss/commons.scss
// module id = 243
// module chunks = 6